import { render, staticRenderFns } from "./Logovanje.vue?vue&type=template&id=552bdf61&"
import script from "./Logovanje.vue?vue&type=script&lang=js&"
export * from "./Logovanje.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports